import cn from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { root } from './Markdown.module.scss';

const Markdown = ({ content, className, children }) => {
  function createMarkup() {
    return { __html: content };
  }
  return (
    <>
      { children ? <div className={cn(root, className)}>{children}</div>
        : <div className={cn(root, className)}>
        <span dangerouslySetInnerHTML={createMarkup()}></span>
      </div> }
    </>
  )
};

Markdown.propTypes = {
  className: PropTypes.string,
  content: PropTypes.string.isRequired,
  children: PropTypes.node,
};
Markdown.defaultProps = {
  content: '',
  children: null
}

export default Markdown;
